import api from "./api"


const cleanParams = (
  params = {}
) =>
  Object.fromEntries(
    Object.entries(
      params
    ).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all"
    )
  )


export const getDashboardProFormData =
  async () => {
    const response =
      await api.get(
        "/dashboard-pro/form-data"
      )

    return response.data
  }


export const getDashboardProOverview =
  async (
    params = {}
  ) => {
    const response =
      await api.get(
        "/dashboard-pro/overview",
        {
          params:
            cleanParams(
              params
            ),
        }
      )

    return response.data
  }
